import {HttpClient} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BdAppEnvironmentService } from '@bindoc-projects/platform-lib/data';
import { ApiEndpointKey } from '@bindoc-projects/app-config-domain-lib';
import { AysFab } from '@bindoc-projects/clinic-domain-lib';
import {catchError, forkJoin, from, Observable, of} from 'rxjs';
import {map, take} from 'rxjs/operators';
import {AysFabStore} from "./fab.store";

@Injectable({
  providedIn: 'root',
})
export class AysFabService {
  private _http = inject(HttpClient);
  private _environmentService = inject(BdAppEnvironmentService);

  private readonly _store: AysFabStore;

  constructor() {
    this._store = new AysFabStore(this._environmentService.load(ApiEndpointKey.AYS_FAB_RESOURCE_URL));
  }

  public index(): Observable<AysFab[]> {
    const url = this._store.indexResource();

    return this._http.get<{ fabKey: string; name: string }[]>(url).pipe(
      map((fabObjs) => {
        return fabObjs.map(
          (fabObj) => new AysFab(fabObj.fabKey, fabObj.name),
        );
      }),
    );
  }

  public get(fabKey: string): Observable<AysFab> {
    const url = this._store.byFabKeyResource(fabKey);

    return this._http
      .get<{ fabKey: string; name: string }>(url)
      .pipe(
        take(1),
        map((res) => new AysFab(res.fabKey, res.name)),
      );
  }

  public getAll(fabKeys: string[]): Observable<{ [fabKey: string]: AysFab }> {
    const reqs: Observable<AysFab>[] = fabKeys.map((fabKey) =>
      from(this.get(fabKey)).pipe(catchError(() => of(null))),
    );

    return forkJoin(reqs).pipe(
      map((fabs) => {
        return fabs
          .filter((it) => !!it)
          .reduce(
            (previousValue: { [fabKey: string]: AysFab }, currentValue) => {
              previousValue[currentValue.fabKey] = currentValue;

              return previousValue;
            },
            {},
          );
      }),
    );
  }
}
